import React from 'react';
import { createPortal } from 'react-dom';
import { FormattedMessage } from 'react-intl';

import { VinHintPlaceholder } from '../common/ImageRepository';
import styles from '../common/styles/HintButton.module.css';

import { Slider } from './Slider';

interface VinSliderProps {
	isOpen: boolean;
	onClose: () => void;
}

export const VinSlider = ({ isOpen, onClose }: VinSliderProps) => {
	return (
		<>
			{isOpen &&
				createPortal(
					<Slider
						title={<FormattedMessage id="hint.vin.title" />}
						isOpen={isOpen}
						onClose={onClose}
					>
						<div className={styles.hintContent}>
							<p className={styles.descriptionHeader}>
								<FormattedMessage id="hint.vin.description" />
							</p>
							<VinHintPlaceholder id={styles.vinHint} />
							<ol className={styles.vinHintList}>
								<li>
									<FormattedMessage id="hint.vin.location1" />
								</li>
								<li>
									<FormattedMessage id="hint.vin.location2" />
								</li>
								<li>
									<FormattedMessage id="hint.vin.location3" />
								</li>
								<li>
									<FormattedMessage id="hint.vin.location4" />
								</li>
							</ol>
						</div>
					</Slider>,
					document.body
				)}
		</>
	);
};
